import DataApi from './DataApi';
import * as constants from '../constants/CONSTANT';

class MisIntegrationApi {
  constructor() {
    this.api = new DataApi('misintegration');
  }

  syncCallRecords(payload) {
    console.log('[MisIntegrationApi] syncCallRecords request : ', payload);
    return this.api.post('/sync', payload);
  }

  fetchSettings() {
    console.log('[MisIntegrationApi] fetchSettings request');
    return this.api.get('/settings');
  }

  saveSettings(data) {
    console.log('[MisIntegrationApi] saveSettings request:', { ...data, client_api_key: data.client_api_key ? '***redacted***' : undefined });
    return this.api.put('/settings', data);
  }
}

const misIntegrationApi = new MisIntegrationApi();
export default misIntegrationApi;
